export default __webpack_public_path__ + "static/media/1076.17522139.png";